function deepEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) { return true } // Примитивы и ссылки на один объект

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false // Если один из них не объект или null
  }

  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) { return false } // Разное количество ключей

  return keys1.every(key => {
    if (key === 'dateRange') { // Особая обработка поля dateRange, так как необходимо учитывать только уникальные значения
      const range1 = obj1[key] ? [...new Set(obj1[key])] : []
      const range2 = obj2[key] ? [...new Set(obj2[key])] : []

      return range1.length === range2.length && range1.every((val, i) => val === range2[i])
    }

    return deepEqual(obj1[key], obj2[key]) // Рекурсивно сравниваем значения
  })
}

export default deepEqual
